var AssetFuelConsumptionUtility = {

    getExcelExportHeaderRow: function() {
        return [
            i18next.t('assetFuelSummaryExcelExport_jobTitle'),
            i18next.t('assetFuelSummaryExcelExport_jobNo'),
            i18next.t('assetFuelSummaryExcelExport_customerNumber'),
            i18next.t('assetFuelSummaryExcelExport_customerName'),
            i18next.t('assetFuelSummaryExcelExport_customerProjectNumber'),
            i18next.t('assetFuelSummaryExcelExport_customerProjectName'),
            i18next.t('assetFuelSummaryExcelExport_jobFromPlaceName'),
            i18next.t('assetFuelSummaryExcelExport_jobToPlaceName'),
            i18next.t('assetFuelSummaryExcelExport_jobTotalDistance'),
            i18next.t('assetFuelSummaryExcelExport_reportStartTimeStamp'), 
            i18next.t('assetFuelSummaryExcelExport_reportEndTimeStamp'),
            i18next.t('assetFuelSummaryExcelExport_assetNo'), // report or job resource row
            i18next.t('assetFuelSummaryExcelExport_assetName'), // report or job resource row
            i18next.t('assetFuelSummaryExcelExport_environmentalClass'), // report or job resource row
            i18next.t('assetFuelSummaryExcelExport_fuelType'), // report or job resource row
            i18next.t('assetFuelSummaryExcelExport_assetMeasurementMethod'), // report or job resource row
            i18next.t('assetFuelSummaryExcelExport_consumption'),
            i18next.t('assetFuelSummaryExcelExport_unit'),
        ]
    },
    summaryEntryToRow: function(entry) {
        var rows = [];
        if (entry.get('reportEntries') && entry.get('reportEntries').length > 0) {
            entry.get('reportEntries').forEach(function(subRow) {
                var row = [];
                var customerNumber = subRow.customerNo || entry.get('customerNo') || '';
                var customerName = subRow.customerName || entry.get('customerName') || '';
                var customerProjectNumber = subRow.customerProjectNo || entry.get('customerProjectNo') || '';
                var customerProjectName = subRow.customerProjectName || entry.get('customerProjectName') || '';
                var distance = subRow.distanceTravelled || entry.get('jobTotalDistance') || '';

                var rowAsset = null;
                var asset = subRow.asset || entry.get('asset');
                if (asset) {
                    rowAsset = {
                        assetNo: asset.assetNo,
                        assetName: asset.assetName,
                        fuelType: asset.assetFuelType ? i18next.t(asset.assetFuelType.toLowerCase()) : '',
                        environmentalClass: asset.assetEnvironmentalClass ? i18next.t('environmentalClass_' + asset.assetEnvironmentalClass.toLowerCase()) : '',
                        measurementMethod: asset.assetMeasurementMethod ? i18next.t('measurementMethod_' + asset.assetMeasurementMethod) : '',
                        fuelUnit: asset.assetFuelUnit
                    }
                } else {
                    rowAsset = {
                        assetNo: '',
                        assetName: '',
                        fuelType: '',
                        environmentalClass: '',
                        measurementMethod: '',
                        fuelUnit: ''
                    }
                }

                var reportStartTime = Formatting.date(subRow.startTime, null) || '';
                var reportEndTime = Formatting.date(subRow.endTime, null) || '';

                row.push(entry.get('jobTitle') || '');
                row.push(entry.get('jobNo') || '');
                row.push(customerNumber);
                row.push(customerName);
                row.push(customerProjectNumber);
                row.push(customerProjectName);
                row.push(entry.get('jobFromLocationPlaceName') || '');
                row.push(entry.get('jobToLocationPlaceName') || '');
                row.push(distance);
                row.push(reportStartTime);
                row.push(reportEndTime);
                row.push(rowAsset.assetNo);
                row.push(rowAsset.assetName);
                row.push(rowAsset.environmentalClass);
                row.push(rowAsset.fuelType);
                row.push(rowAsset.measurementMethod);
                row.push(subRow.consumedFuel);
                row.push(rowAsset.fuelUnit);
                rows.push(row);
            }, this);
        } else if (entry.get('jobResourceEntries') && entry.get('jobResourceEntries').length > 0) {
            entry.get('jobResourceEntries').forEach(function(subRow) {
                var row = [];
                row.push(entry.get('jobTitle') || '');
                row.push(entry.get('jobNo') || '');
                row.push(entry.get('jobCustomerNo') || '');
                row.push(entry.get('jobCustomerName') || '');
                row.push(entry.get('jobCustomerProjectNo') || '');
                row.push(entry.get('jobCustomerProjectName') || '');
                row.push(entry.get('jobFromLocationPlaceName') || '');
                row.push(entry.get('jobToLocationPlaceName') || '');
                row.push(entry.get('jobTotalDistance') || '');
                row.push('');
                row.push('');

                var asset = subRow.asset;
                row.push(asset.assetNo || '');
                row.push(asset.assetName || '');
                row.push(asset.assetEnvironmentalClass ? i18next.t('environmentalClass_' + asset.assetEnvironmentalClass.toLowerCase()) : '');
                row.push(asset.assetFuelType ? i18next.t(asset.assetFuelType.toLowerCase()) : '');
                row.push(asset.assetMeasurementMethod ? i18next.t('measurementMethod_' + asset.assetMeasurementMethod) : '');
                row.push(subRow.consumedFuel || '');
                row.push(asset.assetFuelUnit || '');
                rows.push(row);
            }, this);
        } else {
            // pretty sure we'll never reach this case, since
            // we should always have at least 1 report or job resource row.
            // i guess we'll see!
            var row = [];
            row.push(entry.get('jobTitle') || i18next.t('none'));
            row.push(entry.get('jobCustomerNo') || '');
            row.push(entry.get('jobCustomerName') || '');
            row.push(entry.get('jobCustomerProjectNo') || '');
            row.push(entry.get('jobCustomerProjectName') || '');
            row.push(entry.get('jobFromLocationPlaceName') || i18next.t('none'));
            row.push(entry.get('jobToLocationPlaceName') || i18next.t('none'));
            row.push(entry.get('jobTotalDistance') || i18next.t('none'));
            row.push(entry.get('assetNo') || '');
            row.push(entry.get('assetName') || '');
            row.push(entry.get('assetFuelType') || '');
            row.push(entry.get('assetEnvironmentalClass') || '');
            row.push(entry.get('assetMeasurementMethod') || '');
            row.push(entry.get('consumedFuel') || '');
            row.push(entry.get('assetFuelUnit') || '');
            rows.push(row);
        }
        return rows;
    },
    consumptionBySummaryEntry: function(entry) {
        if (!entry) return '';
        var distance = entry.get('totalDistance');
        var avgConsumption = entry.get('averageFuelConsumption');
        if (distance && avgConsumption) {
            var totalConsumtion = (Math.round(distance * avgConsumption) / 100) / 100;
            return totalConsumtion.toString();
        }
        return ''
    },
    consumption: function(distance, asset) {
        if (distance && asset && asset.fuelType && asset.averageFuelConsumption) {
            var totalConsumtion = (Math.round(distance * asset.averageFuelConsumption) / 100);
            var unit = this.getFuelConsumptionUnit(asset.fuelType);
            return totalConsumtion.toString() + ' ' + unit;
        }
        return ''
    },
    hoursFromReport: function(report) {
        var startTime = report.get('startTime');
        var endTime = report.get('endTime');
        if (!startTime || !endTime) return 0;
        var time = (endTime - startTime) / 1000 / 60 / 60;
        if (time < 0) time += 24;
        var pauseDuration = report.get('pauseDuration') || 0;
        return Math.max(0, time - pauseDuration / 60);
    },
    consumptionFromReports: function(reports, asset, fallbackDistance) {
        var measurementMethod = asset.measurementMethod || 'DISTANCE';
        if (measurementMethod === 'DISTANCE') {
            var distance = _(reports).reduce(function(sum, report) {
                return sum + (report.get('fuelConsumptionDistance') || 0);
            }, 0) || fallbackDistance || 0;
            return Math.round(asset.averageFuelConsumption * distance) / 100;
        }
        if (measurementMethod === 'TIME') {
            var self = this;
            var totalHours = _(reports).reduce(function(sum, report) {
                return sum + self.hoursFromReport(report);
            }, 0);
            return Math.round(asset.averageFuelConsumption * totalHours * 100) / 100;
        }
        return 0;
    },
    getFuelConsumptionUnit: function(fuelType) {
        switch (fuelType) {
            case 'DIESEL':
            case 'ETHANOL':
            case 'GASOLINE':
            case 'HVO':
                return 'L';
            case 'ELECTRICITY':
                return 'kWh';
            case 'HYDROGEN':
            case 'FUEL_GAS':
                return 'Kg';
            default:
                return '';
        }
    },
    getFuelUnit: function(fuelType, measurementMethod) {
        if (!measurementMethod) measurementMethod = 'DISTANCE';
        var firstUnit = '';
        switch (fuelType) {
            case 'DIESEL':
            case 'ETHANOL':
            case 'GASOLINE':
            case 'HVO':
                firstUnit = 'L';
                break;
            case 'ELECTRICITY':
                firstUnit = 'kWh';
                break;
            case 'HYDROGEN':
            case 'FUEL_GAS':
                firstUnit = 'kg';
                break;
            default:
                firstUnit = null;
            }

        secondUnit = '';
        switch (measurementMethod) {
            case 'DISTANCE':
                secondUnit = '100km'
                break;
            case 'TIME':
                secondUnit = 'h'
                break;
            default:
                secondUnit = null;
        }

        return firstUnit && secondUnit ? firstUnit + '/' + secondUnit : '';
    },
}